import { render, staticRenderFns } from "./LbaCombobox.vue?vue&type=template&id=16dc8bce"
import script from "./LbaCombobox.vue?vue&type=script&lang=js"
export * from "./LbaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports